import React, {useState, useRef} from 'react'
import {ControlButton} from '../UIGameReplayControls/ReplayControlsContent/ControlButton'
import {Spinner} from '@colonist/ui'
import IconShare from '@static/images/icon_share.svg'

interface GameResultsControlsShareButtonProps {
    onShare: VoidFunction
    spinnerClassName: string
}

export const GameResultsControlsShareButton = ({
    onShare,
    spinnerClassName,
}: GameResultsControlsShareButtonProps) => {
    const [isLoading, setIsLoading] = useState(false)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    const handleShare = () => {
        if(timeoutRef.current) return

        onShare()
        setIsLoading(true)
        timeoutRef.current = setTimeout(() => {
            setIsLoading(false)
            timeoutRef.current = null
        }, 1500)
    }

    if(isLoading) return <Spinner className={spinnerClassName} />

    return <ControlButton
        icon={IconShare}
        alt="strings:imgAlts.Share"
        onClick={handleShare}
        disableTooltip={true}
    />
}
